import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
//import $ from 'jquery';
//import Swal from 'sweetalert2';

//import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import DownloadingTip from '@/views/Notes/components/DownloadingTip.vue';
import NoteSideBar from '@/views/Notes/NoteDetail/components/NoteSideBar.vue';
import NoteToc from '@/views/Notes/NoteDetail/components/NoteToc.vue';
import QuestionNoteContent from '@/views/Notes/NoteDetail/components/QuestionNoteContent.vue';
import VideoNoteContent from '@/views/Notes/NoteDetail/components/VideoNoteContent.vue';
import NoteModal from '@/views/Notes/NoteDetail/components/NoteModal.vue';
//import { DOWNLOAD_NOTE_IN_DETAIL } from '@/constants/api';
import { QuestionMixin } from '@/mixins/Question';
import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';
import { TimetagInHtmlMixin } from '@/mixins/MtEditor/TimetagInHtmlMixin';
import { NotesDownloadMixin } from '@/scripts/Notes/mixins/NotesDownload';

import { LOADING_MESSAGE } from './NoteDetail.constants';

///
const RouteCourseBookIdMixin = {
  name: 'RouteCourseBookIdMixin',

  computed: {
    c_courseId() {
      return Number(this.$route.params.courseId);
    },

    c_bookId() {
      return Number(this.$route.params.bookId);
    },
  },
};

/// RouteCourseBookIdMixin
const GetNoteDetailMixin = {
  name: 'GetNoteDetailMixin',

  data: () => {
    return {
      promiseNoteDetail: null,
    };
  },

  methods: {
    ...mapActions('Notes/NoteDetail', {
      ma_getNotesDetail: 'getNotesDetail',
    }),

    getNotesDetail() {
      this.promiseNoteDetail = this.ma_getNotesDetail({
        courseId: this.c_courseId,
        bookIds: this.c_bookId,
      });
    },
  },

  created() {
    this.getNotesDetail();
  },
};

// GetNoteDetailMixin
const NoteSideBarShowFirstReadingMixin = {
  name: 'NoteSideBarShowFirstReadingMixin',

  methods: {
    async NoteSideBarShowFirstReadingMixinMounted() {
      await this.promiseNoteDetail;
      await this.$nextTick();
      this.$refs.NoteSideBar.showFirstReading();
    },
  },

  mounted() {
    this.NoteSideBarShowFirstReadingMixinMounted();
  },
};

/// RouteCourseBookIdMixin
const DownloadNoteMixin = {
  name: 'DownloadNoteMixin',

  mixins: [NotesDownloadMixin],

  components: {
    DownloadingTip,
  },

  computed: {
    ...mapState('Notes', {
      ms_isGeneratingPdf: 'isGeneratingPdf',
    }),

    ...mapGetters('Notes/NoteDetail', {
      mg_noteBookDetail: 'noteBookDetail',
    }),

    ///
    c_selectedCourseForDownload() {
      return {
        courseId: this.c_courseId,
        courseName: this.mg_noteBookDetail.courseName,
      };
    },

    c_selectedBookForDownload() {
      return {
        bookId: this.c_bookId,
        bookName: this.mg_noteBookDetail.bookName,
      };
    },

    ///
    c_strSelectedBookIdsForDownload() {
      return `${this.c_selectedBookForDownload.bookId}`;
    },

    ///
    c_downloadFilename() {
      let filename = `${this.c_selectedCourseForDownload.courseName}_`;
      filename += `${this.c_selectedBookForDownload.bookName}.pdf`;
      return filename;
    },
  },

  methods: {
    ///
    generateFileRft() {
      if (!this.ms_isGeneratingPdf) {
        this.doGenerateFileRft();
      }
    },
  },
};

const ScrollToNoteMixin = {
  name: 'ScrollToNoteMixin',

  data: () => {
    return {
      cancelScroll: null,
    };
  },

  computed: {
    ...mapGetters('Notes/NoteDetail', {
      mg_currentNote: 'currentNote',
    }),

    c_scrollToTarget() {
      return `#note_${this.mg_currentNote.bulletId}_${this.mg_currentNote.noteIdx}`;
    },
  },

  methods: {
    scrollToNote() {
      if (this.cancelScroll) {
        this.cancelScroll();
      }
      this.cancelScroll = this.$scrollTo(this.c_scrollToTarget, 500, {
        easing: 'linear',
        offset: -75,
      });
    },
  },
};

const NoteExerciseMixin = {
  name: 'NoteExerciseMixin',

  mixins: [QuestionMixin],

  computed: {
    ...mapGetters('Notes/NoteDetail', {
      mg_currentNote: 'currentNote',
    }),
  },

  methods: {
    openNoteQuestion() {
      this.openQuestion(this.mg_currentNote);
    },
  },
};

const OpenNotePlayerMixin = {
  name: 'OpenNotePlayerMixin',

  data: () => {
    return {
      isShowPlayer: false,
    };
  },

  methods: {
    //
    setCurrentVideo() {
      //
    },

    openPlayer() {
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    openNotePlayer() {
      this.setCurrentVideo();
      this.openPlayer();
    },
  },
};

// ClassRestrictionMixin, TimetagInHtmlMixin
const TimetagPlayerMixin = {
  name: 'TimetagPlayerMixin',

  computed: {
    ...mapGetters('Notes/NoteDetail', {
      mg_currentNote: 'currentNote',
    }),
  },

  methods: {
    clickNoteContent(e) {
      this.clickTimeTag(this.mg_currentNote, e);
    },
  },
};

// GetNoteDetailMixin
/// RouteCourseBookIdMixin
const NotePlayerMixin = {
  name: 'NotePlayerMixin',

  mixins: [
    //
    ClassRestrictionMixin,
    OpenNotePlayerMixin,
    TimetagInHtmlMixin,
    TimetagPlayerMixin,
  ],

  computed: {
    ...mapGetters('Notes/NoteDetail', {
      mg_noteBookDetail: 'noteBookDetail',
      mg_currentNote: 'currentNote',
    }),

    //
    c_courseId() {
      //return -1;
    },

    ///
    c_restrictStudent() {
      return this.mg_noteBookDetail.restrictStudent;
    },
  },

  methods: {
    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = this.promiseNoteDetail;
    },

    ///
    setCurrentVideo() {
      this.currentVideo = { ...this.mg_currentNote };
    },
  },
};

export default {
  name: 'NoteDetail',

  mixins: [
    GetNoteDetailMixin,
    NoteSideBarShowFirstReadingMixin,
    DownloadNoteMixin,
    ScrollToNoteMixin,
    NoteExerciseMixin,
    NotePlayerMixin,
    RouteCourseBookIdMixin,
  ],

  components: {
    //Footer,
    Spinner,
    NoteSideBar,
    NoteToc,
    QuestionNoteContent,
    VideoNoteContent,
    NoteModal,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('Notes/NoteDetail', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters('Notes/NoteDetail', {
      mg_noteBookDetail: 'noteBookDetail',
      mg_currentBullet: 'currentBullet',
      mg_currentBulletVideoNotes: 'currentBulletVideoNotes',
      mg_currentBulletQuestionNotes: 'currentBulletQuestionNotes',
    }),
  },

  methods: {
    ...mapMutations('Notes/NoteDetail', {
      mm_SET_READING_IDX: 'SET_READING_IDX',
    }),

    goBack() {
      this.$router.go(-1);
    },

    selectReading(readingIdx) {
      this.mm_SET_READING_IDX(readingIdx);
    },
  },

  created() {
    this.selectReading(0);
  },
};
